module.exports = __webpack_public_path__ + "img/face_with_head_bandage.9987e288.gif";